import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { IHealthInsuranceState } from './store/healthInsurance.state';
import { getHealthInsuranceSelectors } from './store/healthInsurance.selectors';
import { setHealthInsuranceAction } from './store/healthInsurance.actions';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { IJobFormState } from '../job-form/store/job-form.state';
import { getJobFormSelectors } from '../job-form/store/job-form.selectors';
import { IHealthInsurance } from 'src/app/modules/interfaces/health-insurance.interface';
import { HealthInsuranceService } from 'src/app/services/health-insurance.service';
import { ProfessionService } from 'src/app/services/professions.service';
import { getCookie } from 'src/app/utils/get-cookie';

@Component({
  selector: 'app-health-insurance',
  templateUrl: './health-insurance.component.html',
  styleUrls: ['./health-insurance.component.scss'],
})
export class HealthInsuranceComponent implements OnInit {
  @Output() formSaved = new EventEmitter<void>();
  formsId: number;

  healthInsuranceData: IHealthInsurance = {
    id: 0,
    has_insurance: null,
    insurance_name: '',
    wants_health_plan_study: null,
  };

  isLoading = true;
  showPropo = false;
  isSaving = false;
  saveButtonText = 'Salvar';
  saveButtonClass = 'btn-primary';

  dataState$: Observable<IHealthInsuranceState>;
  dataJob$: Observable<IJobFormState>;
  dataJob: IJobFormState;
  dataState: IHealthInsuranceState;

  constructor(
    private store: Store,
    private healthInsuranceService: HealthInsuranceService,
    private professionsService: ProfessionService
  ) {
    this.formsId = Number(getCookie('formsId'));
  }

  ngOnInit(): void {
    this.getState();
    this.getJobState();
    this.checkJobType()
    this.loadHealthInsuranceData()
  }

  loadHealthInsuranceData(): void {
    this.isLoading = true;
    this.healthInsuranceService.getHealthInsuranceData(this.formsId).subscribe((response) => {
      if (response) {
        this.healthInsuranceData = {
          id: response.id,
          has_insurance: response.has_insurance,
          insurance_name: response.insurance_name || '',
          wants_health_plan_study: response.wants_health_plan_study,
        };

        this.saveState()
        this.updateStatus()
      }
    });
  }

  checkJobType(): void {
    this.professionsService.getProfession(this.formsId).subscribe((response) => {
      if (response && response.work_modalities?.name === 'Pessoa Jurídica / Empresário') {
        this.showPropo = true;
      } else {
        this.showPropo = false;
      }
    });
  }

  saveForm(): void {
    this.isSaving = true;
    this.saveButtonText = 'Salvando...';
    this.saveButtonClass = 'btn-secondary';

    const updateData: any = {
      has_insurance: this.healthInsuranceData.has_insurance,
      insurance_name: this.healthInsuranceData.insurance_name || null,
      wants_health_plan_study: this.healthInsuranceData.wants_health_plan_study ? 1 : 0,
    };

    this.healthInsuranceService.updateHealthInsuranceData(this.formsId, this.healthInsuranceData.id, updateData).subscribe({
      next: () => {
        this.isSaving = false;
        this.saveButtonText = 'Salvo';
        this.saveButtonClass = 'btn-primary';
        this.saveState()
        this.updateStatus()
        this.formSaved.emit();
      },
      error: () => {
        this.isSaving = false;
        this.saveButtonText = 'Erro ao salvar';
        this.saveButtonClass = 'btn-danger';
      },
    });
  }

  saveState():void {
    this.dataState = {
      ...this.dataState,
      check: true,
      insurance: this.healthInsuranceData.has_insurance === 1,
      insuranceName: this.healthInsuranceData.insurance_name || '',
      interest: this.healthInsuranceData.wants_health_plan_study === 1, 
    };

    this.setState(this.dataState);
  }

  onFieldChange(): void {
    if (!this.isSaving) {
      this.saveButtonText = 'Salvar';
      this.saveButtonClass = 'btn-primary';
    }
  }

  startTrial(): void {
    this.setState(this.dataState);
  }

  setState(data: IHealthInsuranceState) {
    this.store.dispatch(setHealthInsuranceAction(data));
    this.isLoading = false;
  }

  getState() {
    this.dataState$ = this.store.select(getHealthInsuranceSelectors);

    this.dataState$.subscribe((value) => {
      this.dataState = {
        ...(this.dataState = value),
      };
    });
  }

  getJobState() {
    this.dataJob$ = this.store.select(getJobFormSelectors);

    this.dataJob$.subscribe((value) => {
      this.dataJob = {
        ...(this.dataJob = value),
      };
    });
  }

  setValuesForm(): void {
    this.dataState.check = false;
    if (this.dataState.insurance != undefined) {
      this.dataState.check = true;
    }
    this.setState(this.dataState);
  }

  setOption(item: string, option: string, value: boolean) {
    // Criar uma cópia do estado atual
    this.dataState = {
      ...this.dataState,
      [item]: {
        ...this.dataState[item],
        [option]: value,
      },
    };

    // Atualizar o estado usando o método `setState`
    this.setState(this.dataState);
    this.updateStatus();
  }

  updateStatus() {
    if (
      this.dataState.insurance &&
      this.dataJob.typeJob == 'Pessoa Jurídica / Empresário'
    ) {
      this.showPropo = true;
    } else {
      this.showPropo = false;
    }
  }
}
